export default __webpack_public_path__ + "static/media/PC-MAC.2042c2e5.png";